import ParamsService from '@/utils/ParamsService';
import isString from 'lodash/isString';
export const USER_MATCHING_TEXT = 'The user that triggered the feature';
export const USER_MATCHING_TYPE = 'user_matching';
export const USER_MATCHING_OPTION_TEXT = 'user_matching';
export const USER_MATCHING_SELECT_OPTIONS = {
	EMPTY: 'leave_empty',
	CHOOSE: 'choose_fallback',
	ERROR: 'display_error',
};

const buildUserMatchingOption = (rootNode, nodeID, inputFieldKey) => ({
	type: USER_MATCHING_TYPE,
	option: USER_MATCHING_TEXT,
	value: ParamsService.buildKeyForPath(rootNode, nodeID, `${USER_MATCHING_OPTION_TEXT}.${inputFieldKey}.id`),
});

const validFallback = (fallback) => {
	if (!fallback) {
		return false;
	}
	if (fallback.type == USER_MATCHING_SELECT_OPTIONS.CHOOSE) {
		return fallback.details && fallback.details.hasOwnProperty('id') && fallback.details.hasOwnProperty('name');
	}
	return fallback.type != '';
};

const initialFallbackType = (isRequired) => (isRequired ? USER_MATCHING_SELECT_OPTIONS.ERROR : USER_MATCHING_SELECT_OPTIONS.EMPTY);

const initialFallback = (isRequired) => ({ type: initialFallbackType(isRequired), details: {} });

const isValueOfUserMatching = (paramMapValue) => isString(paramMapValue) && paramMapValue.includes(USER_MATCHING_OPTION_TEXT);

const UserMatchingService = {
	buildUserMatchingOption,
	validFallback,
	initialFallbackType,
	initialFallback,
	USER_MATCHING_TYPE,
	USER_MATCHING_TEXT,
	USER_MATCHING_OPTION_TEXT,
	USER_MATCHING_SELECT_OPTIONS,
	isValueOfUserMatching,
};

export default UserMatchingService;
